/**
 * Route IDs for the Partner application.
 * Used by AppRouterService and feature group router services to navigate
 * and check the current active route.
 */
export enum PartnerRoutingId {
    Welcome = "WELCOME",
    ApiCredentials = "API_CREDENTIALS",
    DealsApi = "DEALS_API",
    DealsApiVersion = "DEALS_API_VERSION",
    Inspire = "INSPIRE",
    InspireOverview = "INSPIRE_OVERVIEW",
    InspireDocumentation = "INSPIRE_DOCUMENTATION"
}
